import React from 'react';

import Routes from "../../components/translations/routes/Routes";
import {QuicktHeader} from "../../base/header/QuicktHeader";

const TranslationsPage = () => {

    return (
        <>
            <QuicktHeader />
            <Routes/>
        </>
    );
};

export default TranslationsPage;